import React, { useEffect, useRef } from "react";
import "./CloseButton.scss";

interface IProps {
    show?: boolean
    onClick: () => void
}

export function CloseButton({onClick, show}: IProps) {
    const shouldShow = show === undefined ? true : show;
    const ref = useRef<HTMLButtonElement>(null);

    useEffect(() => {
        if (!ref.current) return;
        const button = ref.current;
        const handleClick = () => {
            onClick();
        }
        button.addEventListener('pointerdown', handleClick);
        return () => {
            button.removeEventListener('pointerdown', handleClick);
        }
    }, [onClick, ref]);

    return (
        <div className={`close-button-wrapper ${shouldShow ? 'show' :''}`}>
            <button ref={ref}>
                <svg xmlns="http://www.w3.org/2000/svg" width="22.628" height="22.627" viewBox="0 0 22.628 22.627">
                    <g id="Group_7" data-name="Group 7" transform="translate(1605.84 514.067) rotate(45)">
                        <rect id="Rectangle_255" data-name="Rectangle 255" width="28" height="4" rx="2" transform="translate(-1497 770)" fill="#333"/>
                        <rect id="Rectangle_256" data-name="Rectangle 256" width="4" height="28" rx="2" transform="translate(-1485 758)" fill="#333"/>
                    </g>
                </svg>
            </button>
        </div>
    )
}
